export default __webpack_public_path__ + "static/PentanetGG-2a906629dfcaa700b9e330f242746a24.png";